import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  _idSocio: Yup.string().required(),
  fechaDesde: Yup.string().required(),
  fechaHasta: Yup.string().required()
})
